import { gql, useMutation } from '@apollo/client';

import { LWC_DETAILS_FOR_BROKERAGE_QUERY } from '../queries/BrokerageLwcDetails';
import { LWC_DETAILS_QUERY } from '../queries/LwcDetails';
import { SelectDirectSale, SelectDirectSaleVariables } from './__generated__/SelectDirectSale';

export const SELECT_DIRECT_SALE = gql`
  mutation SelectDirectSale($lwcProductId: String!) {
    odProtosListingsServicesListwithcertaintyproduct {
      selectDirectSale(input: { lwcProductId: $lwcProductId }) {
        _empty
      }
    }
  }
`;

/**
 * This mutation is used for opting into direct sale after listing
 * agreement signing. Opting into direct sale prior to listing agreement
 * being signed is a CustomerDecline mutation with reason DNC_DIRECT_SALE_ONLY
 */
export const useSelectDirectSale = () => {
  const [selectDirectSaleMutation, { data, error, loading }] = useMutation<
    SelectDirectSale,
    SelectDirectSaleVariables
  >(SELECT_DIRECT_SALE, {
    fetchPolicy: 'no-cache',
    context: {
      clientName: 'athena',
    },
    refetchQueries: [LWC_DETAILS_QUERY, LWC_DETAILS_FOR_BROKERAGE_QUERY],
  });

  const selectDirectSale = (lwcProductId: string) =>
    selectDirectSaleMutation({
      variables: { lwcProductId },
    });
  return { selectDirectSale, data, loading, error };
};
